import React from 'react';
import { CheckIcon, ShieldCheckIcon } from 'lucide-react';
import { CTAButton, PRICE, PRICE_SHORT, PRODUCT_SPEC, Section } from './Shared';
import { Bellflower, Blossom, Daisy, DropperBottle } from './FloralDecor';
const inclusions = ['Downloadable PDF materials', 'Read on a phone, tablet, or computer; print for personal use if useful', '7-day refund policy', 'Payment options are shown securely at checkout'];
export function Pricing() {
  return <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-196" data-mp="1vvv107vbke54">
      <Section id="buy" className="rounded-xl border border-stone-200 rice-paper" data-id="element-197" data-mp="1ru15sf3w82cc">
        <div aria-hidden="true" className="pointer-events-none absolute inset-0 overflow-hidden rounded-xl" data-id="element-198" data-mp="25t0u1lnhuf7z">
          <Blossom className="absolute left-6 top-8 h-20 w-20" petalClassName="text-pink-200" centerClassName="text-amber-300" data-id="element-199" data-mp="20rjupuknr0ti" />
          <Daisy className="absolute right-10 top-10 hidden h-14 w-14 md:block" petalClassName="text-white" centerClassName="text-amber-400" data-id="element-200" data-mp="3h97lfwxkcyrs" />
          <Bellflower className="absolute bottom-0 left-4 hidden h-40 w-20 md:block" petalClassName="text-violet-300/70" centerClassName="text-emerald-300/70" data-id="element-201" data-mp="3w1jhi6uv8s0y" />
          <DropperBottle className="absolute bottom-6 right-8 hidden h-32 w-16 text-amber-700/20 md:block" data-id="element-202" data-mp="9qe69kmdpq2z" />
        </div>

        <h2 className="relative mb-10 text-center text-3xl font-bold tracking-tight text-emerald-900 md:text-4xl" data-id="element-203" data-mp="3d97i9szie6v1">
          Get the complete digital edition
        </h2>

        <div className="relative mx-auto max-w-2xl space-y-6" data-id="element-204" data-mp="3i5xxke3hoyfe">
          <div className="rounded-xl border-2 border-amber-500 bg-white p-6 shadow-md md:p-8" data-id="element-205" data-mp="3n6d7swsh5pt5">
            <div className="flex flex-wrap items-end justify-between gap-6" data-id="element-206" data-mp="3rywt6fxelp8i">
              <div className="max-w-sm" data-id="element-207" data-mp="2uizf5avt7geu">
                <h3 className="text-lg font-bold text-emerald-900 md:text-xl" data-id="element-208" data-mp="2ui7l44hv1qqo">BACH FLOWER CONSULTATION GUIDE</h3>
                <p className="mt-1.5 text-sm text-stone-500" data-id="element-209" data-mp="2zfg3o66x7wsg">{PRODUCT_SPEC}</p>
              </div>
              <div className="shrink-0 text-right" data-id="element-210" data-mp="2rerzc02wskur">
                <p className="text-4xl font-bold tracking-tight text-emerald-700 md:text-5xl" data-id="element-211" data-mp="2mijo2xru1bsv">{PRICE}</p>
                <p className="mt-1 text-xs text-stone-500" data-id="element-212" data-mp="315mphfja04lh">One-time payment · No subscription</p>
              </div>
            </div>

            <ul className="mt-6 grid gap-2.5 border-t border-stone-200 pt-6 sm:grid-cols-2" data-id="element-213" data-mp="2w8cyvwk5hmw2">
              {inclusions.map(item => <li key={item} className="flex gap-2.5 text-sm leading-snug text-stone-900" data-id="element-214" data-mp="23j5tcdma3x1b">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-emerald-700" aria-hidden="true" data-id="element-215" data-mp="2ifwv2tjfdku3" />
                  {item}
                </li>)}
            </ul>

            <CTAButton fullWidth className="mt-7 px-6 py-5 text-base md:text-xl" data-id="element-216" data-mp="2djg7q1k1vai2">
              GET INSTANT DIGITAL ACCESS — {PRICE_SHORT}
            </CTAButton>

            <p className="mt-5 text-center text-xs leading-relaxed text-stone-500" data-id="element-217" data-mp="3ovh2py7ibv69">
              The price is charged in US dollars. Your bank or payment provider may apply its own exchange rate or
              fees. This is a digital product; no printed booklets are shipped.
            </p>
          </div>

          <div id="refund-policy" className="flex scroll-mt-20 gap-4 rounded-lg bg-emerald-50 p-5" data-id="element-218" data-mp="3ngwf0eafcw73">
            <ShieldCheckIcon className="mt-0.5 h-6 w-6 shrink-0 text-emerald-700" aria-hidden="true" data-id="element-219" data-mp="3rgyjev7jo3q2" />
            <div data-id="element-220" data-mp="j1n4lsin9yob">
              <h3 className="font-bold text-emerald-900" data-id="element-221" data-mp="j37rqx2mqfc5">7-day refund policy</h3>
              <p className="mt-1.5 text-sm leading-relaxed text-stone-700" data-id="element-222" data-mp="nz6n54mdkxm2">
                If you would like to request a refund, contact us within 7 calendar days of purchase and follow the
                steps in our Refund Policy. This voluntary refund policy does not limit consumer rights that cannot be
                excluded under the laws that apply to you.
              </p>
            </div>
          </div>
        </div>
      </Section>
    </div>;
}